// Module for html templates registration(in $templateCache)
// Should be included in modules that uses external html files as templates
angular.module('templates', []);